import React, { PropTypes, Component } from 'react';
import { Button } from 'semantic-ui-react';
import $ from 'jquery';
import cx from 'classnames';

class CleanableDatepicker extends Component {
  componentDidUpdate() {
    console.log(this.props);
    const $picker =
      this.props && this.props.identifier
        ? $(`input.datepicker#${this.props.identifier}`)
        : $('input.datepicker');

    $picker.each((_, element) => {
      const $element = $(element);

      const orientation = $element.attr('data-orientation') || 'bottom';
      $element.datepicker('remove');
      $element.attr('autocomplete', 'off');

      $element
        .datepicker({
          language: 'fr',
          autoclose: true,
          orientation,
        })
        .on('changeDate', evt => {
          this.props.onChange(evt);
        });
    });
  }

  render() {
    const {
      className,
      name,
      value,
      disabled,
      identifier,
      onChange,
      placeholder,
      hideButton,
    } = this.props;

    const cleanValue = () => {
      this.props.onChange(null);
    };

    var computeClassName = hideButton ? '' : 'ui action input';

    return (
      <div className={computeClassName}>
        <input
          id={identifier}
          type="text"
          className={cx('datepicker', className)}
          name={name}
          onChange={onChange}
          value={value || ''}
          disabled={disabled}
          placeholder={placeholder}
        />
        {!hideButton && (
          <Button
            basic
            icon="close"
            style={{ borderLeft: 'transparent' }}
            onClick={cleanValue}
          />
        )}
      </div>
    );
  }
}

CleanableDatepicker.propTypes = {
  identifier: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

CleanableDatepicker.defaultProps = {
  className: '',
  disabled: false,
};

export default CleanableDatepicker;



// WEBPACK FOOTER //
// ./src/modules/common/components/CleanableDatepicker.js